/**
 * Mensagem do backend (`errors[0].message`) quando há; senão o texto da tela. Falha técnica (o `ErrorResponse`
 * "Unknown error" do `VaultApiService`, com o status HTTP na mensagem) também cai no texto da tela.
 */
export function describeBriefingError(err: unknown, fallback: string): string {
  const response = err as { message?: string; errors?: { message?: string }[] } | null;
  if (response?.message === 'Unknown error') return fallback;
  const message = response?.errors?.[0]?.message?.trim();
  return message || fallback;
}
